var map = {
	"./ajax-loader.gif": 1,
	"./favicon.png": 58
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;


//////////////////
// WEBPACK FOOTER
// ./src/img \.(gif|png|jpe?g|svg)$
// module id = 57
// module chunks = 0 1